import { combineEpics } from 'redux-observable';
import entityCreated from './entity-created/index.tsx';
import entityUpdated from './entity-updated/index.tsx';

export default combineEpics(entityCreated, entityUpdated);
